import React from "react";
import { useStyles } from "../../../assets/jss/CustomLoader";
import CustomCircularProgress from "../CustomCircularProgress/CustomCircularProgress";
import CustomPaper from "../CustomPaper/CustomPaper";

export default function CustomLoader() {
  const classes = useStyles();
  return (
    <CustomPaper className={classes.loadingContainer} elevation={0}>
      <CustomCircularProgress />
    </CustomPaper>
  );
}
